import { z } from "zod";

const irMobileRegex = /^09\d{9}$/;

export const checkoutPhoneSchema = z.object({
  phone_number: z
    .string()
    .min(1, { error: "شماره موبایل الزامی است" })
    .regex(irMobileRegex, { error: "شماره موبایل باید با 09 شروع و ۱۱ رقم باشد" }),
});

export type CheckoutPhoneFormValues = z.infer<typeof checkoutPhoneSchema>;

// The phone number is not part of this form: it is the one verified by OTP.
export const checkoutCustomerSchema = z.object({
  full_name: z.string().min(1, { error: "نام و نام خانوادگی الزامی است" }),
  province: z.string().min(1, { error: "استان الزامی است" }),
  city: z.string().min(1, { error: "شهر الزامی است" }),
  address: z.string().min(1, { error: "آدرس الزامی است" }),
  postal_code: z
    .string()
    .min(1, { error: "کد پستی الزامی است" })
    .regex(/^\d{10}$/, { error: "کد پستی باید ۱۰ رقم باشد" }),
});

export type CheckoutCustomerFormValues = z.infer<typeof checkoutCustomerSchema>;
